// src/pages/AdminSettings.js
import React, { useState, useEffect } from 'react';
import apiClient from '../services/api';

const AdminSettings = () => {
  const [supportPhone, setSupportPhone] = useState('');
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  // 1. Page load hote hi purani settings fetch karo
  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await apiClient.get('/admin/settings');
      if (response.data.success && response.data.settings) {
        setSupportPhone(response.data.settings.supportPhoneNumber || '');
        setFaqs(response.data.settings.faqs || []);
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    } finally {
      setLoading(false);
    }
  };

  // 2. Naya FAQ add karne ka function
  const handleAddFaq = () => {
    setFaqs([...faqs, { question: '', answer: '' }]);
  };

  // 3. FAQ remove karne ka function
  const handleRemoveFaq = (index) => {
    const updatedFaqs = faqs.filter((_, i) => i !== index);
    setFaqs(updatedFaqs);
  };

  // 4. FAQ me text type karne ka function
  const handleFaqChange = (index, field, value) => {
    const updatedFaqs = [...faqs];
    updatedFaqs[index][field] = value;
    setFaqs(updatedFaqs);
  };

  // 5. Naya Number aur FAQs Database me Save karna! 🔥
  const handleSaveSettings = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const response = await apiClient.put('/admin/settings/support', {
        supportPhoneNumber: supportPhone,
        faqs: faqs
      });

      if (response.data.success) {
        alert("Bhai, Settings Mast Update Ho Gayi! Mobile App check karo.");
      }
    } catch (error) {
      console.error("Error saving settings:", error);
      alert("Oops! Kuch gadbad ho gayi save karne me.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <p style={{ padding: '20px' }}>Loading Settings...</p>;

  return (
    <div style={{ padding: '20px', maxWidth: '800px' }}>
      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#1E293B', marginBottom: '5px' }}>App Settings</h2>
        <p style={{ color: '#64748B' }}>Manage your App's Support Number and FAQs from here.</p>
      </div>

      <form onSubmit={handleSaveSettings} style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
        
        {/* 🔥 SUPPORT PHONE NUMBER FIELD 🔥 */}
        <div style={{ marginBottom: '30px' }}>
          <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '10px', color: '#355ca9' }}>
            Support Phone Number
          </label>
          <input 
            type="text" 
            value={supportPhone} 
            onChange={(e) => setSupportPhone(e.target.value)}
            placeholder="e.g. +91 9876543210"
            style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #CBD5E1', fontSize: '16px' }}
            required
          />
          <small style={{ color: '#94A3B8', marginTop: '5px', display: 'block' }}>
            Jab Vendor "Call Us" dabayega, toh is number par call jayegi.
          </small>
        </div>

        <hr style={{ border: 'none', borderTop: '1px solid #E2E8F0', margin: '30px 0' }} />

        {/* 🔥 DYNAMIC FAQS FIELD 🔥 */}
        <div style={{ marginBottom: '20px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
            <label style={{ fontWeight: 'bold', color: '#355ca9', margin: 0 }}>
              Frequently Asked Questions (FAQs)
            </label>
            <button 
              type="button" 
              onClick={handleAddFaq}
              style={{ backgroundColor: '#10B981', color: '#fff', border: 'none', padding: '8px 15px', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}
            >
              + Add New FAQ
            </button>
          </div>

          {faqs.length === 0 ? (
             <p style={{ color: '#94A3B8', fontStyle: 'italic' }}>Koi FAQ add nahi kiya hai. "Add New FAQ" par click karein.</p>
          ) : (
            faqs.map((faq, index) => (
              <div key={index} style={{ backgroundColor: '#F8FAFC', padding: '15px', borderRadius: '8px', marginBottom: '15px', border: '1px solid #E2E8F0' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                  <strong>FAQ #{index + 1}</strong>
                  <button 
                    type="button" 
                    onClick={() => handleRemoveFaq(index)}
                    style={{ backgroundColor: '#EF4444', color: '#fff', border: 'none', padding: '4px 10px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}
                  >
                    Delete
                  </button>
                </div>
                <input 
                  type="text" 
                  placeholder="Question (e.g., How to get paid?)" 
                  value={faq.question}
                  onChange={(e) => handleFaqChange(index, 'question', e.target.value)}
                  style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #CBD5E1', marginBottom: '10px' }}
                  required
                />
                <textarea 
                  placeholder="Answer (e.g., You will get paid every Tuesday...)" 
                  value={faq.answer}
                  onChange={(e) => handleFaqChange(index, 'answer', e.target.value)}
                  style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #CBD5E1', minHeight: '60px' }}
                  required
                />
              </div>
            ))
          )}
        </div>

        {/* 🔥 SAVE BUTTON 🔥 */}
        <button 
          type="submit" 
          disabled={saving}
          style={{ width: '100%', backgroundColor: '#ea6724', color: '#fff', border: 'none', padding: '15px', borderRadius: '8px', fontSize: '16px', fontWeight: 'bold', cursor: saving ? 'not-allowed' : 'pointer', opacity: saving ? 0.7 : 1 }}
        >
          {saving ? 'Saving...' : 'Save Settings'}
        </button>

      </form>
    </div>
  );
};

export default AdminSettings;